import userDataServiceSDK from '@nerdwallet/nw-api-sdk/user-data-platform-sdk';

import nwApiSdk from './nw-api-sdk';

const { ServiceSDK } = nwApiSdk;

export default userDataServiceSDK(ServiceSDK, {
  userDataPlatformBaseUrl: process.env.USER_DATA_BASE_URL,
});
